import { isValidDate } from '../../../utils/isValidDate';
import { CreateClientRequest } from '../../../types/client';

export default function validateClient(clientData: CreateClientRequest) {

    const {
        deceasedName,
        registeredBy,
        mobileNo,
        email,
        scheduleFrom,
        scheduleTo,
        startTime,
        endTime,
        chapels,
        contactPersons
    } = clientData;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const startDate = new Date(scheduleFrom);
    const endDate = new Date(scheduleTo);

    if (
        !deceasedName?.trim() ||
        !registeredBy?.trim() ||
        mobileNo == '09'||
        !email?.trim() ||
        !scheduleFrom ||
        !scheduleTo ||
        !startTime ||
        !endTime ||
        chapels?.length === 0
    ) {
        return "Please fill in all required fields.";
    }

    if(mobileNo.length !== 11) {
        return "Mobile number must be exactly 11 digits.";
    }

    // 3. Date validation
    if (!isValidDate(scheduleFrom)) return "Invalid start date format.";
    if (!isValidDate(scheduleTo)) return "Invalid end date format.";

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    if (startDate < today) return "Start date cannot be earlier than today.";
    if (endDate < startDate) return "End date cannot be earlier than start date.";

    // 4. Time validation
    if (endTime > "20:59") {
        return "End time must not exceed 08:59 PM";
    }

    for (const contactP of contactPersons || []) {
        const name = contactP.name?.trim();

        const rawNumber = contactP.number?.trim();
        const number = rawNumber === "09" ? "" : rawNumber;

        if (!name && !number) continue;

        if (!/^\d{11}$/.test(number)) {
            return `Contact number must be exactly 11 digits.`;
        }

        if (!name ) {
            return "Please enter a contact person name.";
        }
    }

    return null;
}
